import { useMutation } from '@tanstack/react-query';

import { ExpensesApi } from '../expenses.api';

export const useGetRecalculationsTotalExpanses = () => {
  return useMutation({
    mutationFn: ExpensesApi.getExpensesRecalculationsByCategory,
  });
};
